import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchFavoriteEstates, addFavoriteEstate, removeFavoriteEstate } from '../api/api';

const initialState = {
  favorites: [],
  loading: false,
  error: null
};

export const fetchFavorites = createAsyncThunk(
  'favorites/fetchFavorites',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await fetchFavoriteEstates();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch favorites');
    }
  }
);

export const addFavorite = createAsyncThunk(
  'favorites/addFavorite',
  async (estateId, { rejectWithValue }) => {
    try {
      const { data } = await addFavoriteEstate(estateId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to add favorite');
    }
  }
);

export const removeFavorite = createAsyncThunk(
  'favorites/removeFavorite',
  async (favoriteId, { rejectWithValue }) => {
    try {
      await removeFavoriteEstate(favoriteId);
      return favoriteId;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to remove favorite');
    }
  }
);

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    clearFavorites: (state) => {
      state.favorites = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavorites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFavorites.fulfilled, (state, action) => {
        state.favorites = action.payload;
        state.loading = false;
      })
      .addCase(fetchFavorites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addFavorite.fulfilled, (state, action) => {
        state.favorites.push(action.payload);
      })
      .addCase(removeFavorite.fulfilled, (state, action) => {
        state.favorites = state.favorites.filter(favorite => favorite.id !== action.payload);
      });
  }
});

export const { clearFavorites } = favoritesSlice.actions;
export default favoritesSlice.reducer; 